export const VIDEO_STARTED = 'started'
export const VIDEO_CLOSED = 'closed'
export const VIDEO_ENDED = 'ended'
export const VIDEO_PROGRESS = 'progress'
export const VIDEO_PLAYED = 'played'
export const VIDEO_PAUSED = 'paused'
export const VIDEO_SCRUB_STARTED = 'scrubStarted'
export const VIDEO_SCRUB_ENDED = 'scrubEnded'
export const VIDEO_SKIPPED = 'skipped'
